import { EditableColumnAPI } from '../api';
import { EditableColumn } from '../model/editable-column.model';

const ALL_TASKS_ROW_EDIT_COLUMNS = 'allTasks';

export const mapEditableColumnFromAPIToModel = (column: EditableColumnAPI): EditableColumn => ({
    fieldId: column.fieldId || undefined,
    field: column.field,
    visible: column.visible,
    pinned: column.pinned,
    disabled: column.field === ALL_TASKS_ROW_EDIT_COLUMNS,
    columnIndex: column.columnIndex,
});

export const mapEditableColumnFromModelToAPI = (column: EditableColumn): EditableColumnAPI => ({
    fieldId: column.fieldId,
    field: column.field,
    visible: column.visible,
    pinned: column.pinned,
    columnIndex: column.columnIndex,
});
